import { LitElement, html } from 'lit-element';

class AppPageNav extends LitElement {
    static get properties() {
        return {
            headings: { type: Array }
        };
    }

    createRenderRoot() {
        return this; // Use light DOM instead of shadow DOM
    }

    render() {
        return html`
            <nav>
                <h3 class="title">On This Page</h3>
                <ul class="nav-list">
                    ${this.headings
                        ? this.headings.map(
                              heading => html`
                                  <li class="nav-item">
                                      <a
                                          href="#${this._generateId(heading)}"
                                          class="nav-link"
                                          tabindex="0"
                                          aria-label="${heading}"
                                          >${heading}</a
                                      >
                                  </li>
                              `
                          )
                        : html`<li class="nav-item">No headings available</li>`}
                </ul>
            </nav>
        `;
    }

    _generateId(text) {
        return text
            .toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-');
    }
}

customElements.define('app-pagenav', AppPageNav);
